const initialState = {
  loading: true,
  detail: {}
};

function reducer(state, action) {
  switch (action.type) {
    case 'setLoading':
      return { ...state, loading: action.payload };
    case 'setDetail':
      return { ...state, detail: action.payload };
    default:
  }
}

const setLoading = payload => ({
  type: 'setLoading',
  payload,
});

const setDetail = payload => ({
  type: 'setDetail',
  payload,
});

export {
  initialState,
  reducer,
  setLoading,
  setDetail,
};
